import 'bootstrap/dist/css/bootstrap.css';
import { useEffect, useState } from 'react';
import { Button, Form, Row, Col } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { Regional } from '../../../shared/model/regional';
import { MatrizDTO } from '../../../shared/dto/matrizDTO';
import Spinner from '../../../shared/spinner';
import { ButtonAlterar, ButtonAtivar, ButtonInativar } from '../../../shared/buttons';
import RegionalService from '../../../services/regionalService';
import MatrizService from '../../../services/matrizService';
import ConfirmModal from '../../../shared/customAlertConfirm';
import { useVerificaPermissao } from '../../../shared/useVerificaPermissao';
import { faFilter, faRefresh } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ResponsivePagination from 'react-responsive-pagination';
import { useSlug } from '../../hooks/UseSlug';
import { ProtectedAction } from '../../../AccessControl';

function RegionalComponent() {
  useVerificaPermissao();
  const navigate = useNavigate();
  const slug = useSlug(); // 2. Obtendo o slug
  
  const [loading, setLoading] = useState(true);
  const [regional, setRegional] = useState<Regional[]>([]);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [currentAction, setCurrentAction] = useState<{ id: any; ativo: boolean } | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filtros, setFiltros] = useState(false);
  const [matrizFiltro, setMatrizFiltro] = useState<string>('');
  const [codigoFiltro, setCodigoFiltro] = useState('');
  const [nomeFiltro, setNomeFiltro] = useState('');
  const [cidadeFiltro, setCidadeFiltro] = useState('');
  const [statusFiltro, setStatusFiltro] = useState('');

  const [matrizes, setMatrizes] = useState<MatrizDTO[]>([]);

  const regionalService = new RegionalService();
  const matrizService = new MatrizService();

  const pageSize = 10;

  const listarRegionais = async (page = 1) => {
    try {
      setLoading(true);

      const filtrosData: any = {};
      if (matrizFiltro) filtrosData.matriz = matrizFiltro;
      if (codigoFiltro) filtrosData.codigo = codigoFiltro;
      if (nomeFiltro) filtrosData.nome = nomeFiltro;
      if (cidadeFiltro) filtrosData.cidade = cidadeFiltro;
      if (statusFiltro !== '') filtrosData.ativo = statusFiltro;

      const response = await regionalService.listarRegionais(page - 1, pageSize, filtrosData);
      const data = response.data;

      setRegional(data.content || []);
      setTotalPages(data.totalPages || 1);
      setCurrentPage(page);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page: number) => {
    listarRegionais(page);
  };

  const ativarInativarRegional = (id: any, ativo: boolean) => {
    setCurrentAction({ id, ativo });
    setConfirmOpen(true);
  };

  const handleConfirm = async () => {
    if (currentAction) {
      const { id } = currentAction;
      try {
        await regionalService.ativarInativarRegional(id);
        listarRegionais(currentPage); 
      } catch (err) {
        console.error(err);
      } finally {
        setConfirmOpen(false);
        setCurrentAction(null);
      }
    }
  };

  useEffect(() => {
    listarRegionais(1);

    const carregarMatrizes = async () => {
      try {
        const response = await matrizService.listarTodasMatrizesAtivas();
        setMatrizes(response.data || []);
      } catch (error) {
        console.error("Erro ao carregar matrizes:", error);
      }
    };
    carregarMatrizes();
  }, []);

  return (
    <>
      <div className="position-relative m-md-3">
        <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between' }}>
          <h5>Origens &gt; Regional</h5>
          <div>
            <Button id="App-button-cor-principal-escura" onClick={() => setFiltros(!filtros)} style={{ marginRight: '10px' }}>
              <FontAwesomeIcon icon={faFilter} style={{ marginRight: '10px' }} />
              Filtros
            </Button>
            <ProtectedAction>
              <Button
                // 3. Rota corrigida com Slug
                onClick={() => navigate(`/${slug}/origens-regional/inclusao`, { state: { id: null } })}
                id="App-button-cor-principal-escura"
              >
                + Nova Regional
              </Button>
            </ProtectedAction>
          </div>
        </div>
        
        {filtros && (
          <>
            <Row className="mb-4" style={{ marginTop: '15px' }}>
              <Form.Group as={Col} md='3' controlId="formSelectMatriz">
                <Form.Label>Matriz</Form.Label>
                <Form.Select value={matrizFiltro} onChange={(e) => setMatrizFiltro(e.target.value)}>
                  <option value="">Selecione</option>
                  {matrizes.map((matriz) => (
                    <option key={matriz.id} value={String(matriz.id)}>
                      {matriz.id} - {matriz.nome}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group as={Col} md='2' controlId="formCodigoFiltro">
                <Form.Label>Código</Form.Label>
                <input type="text" className="form-control" value={codigoFiltro} onChange={(e) => setCodigoFiltro(e.target.value)} />
              </Form.Group>
              <Form.Group as={Col} md='4' controlId="formNomeFiltro">
                <Form.Label>Razão Social</Form.Label>
                <input type="text" className="form-control" value={nomeFiltro} onChange={(e) => setNomeFiltro(e.target.value)} />
              </Form.Group>
              <Form.Group as={Col} md='3' controlId="formCidadeFiltro">
                <Form.Label>Cidade</Form.Label>
                <input type="text" className="form-control" value={cidadeFiltro} onChange={(e) => setCidadeFiltro(e.target.value)} />
              </Form.Group>
              <Form.Group as={Col} md='3' controlId="formStatusFiltro">
                <Form.Label>Status</Form.Label>
                <Form.Select value={statusFiltro} onChange={(e) => setStatusFiltro(e.target.value)}>
                  <option value="">Todos</option>
                  <option value="true">Ativos</option>
                  <option value="false">Inativos</option>
                </Form.Select>
              </Form.Group>
            </Row>
            <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <Button id="App-button-cor-principal-escura" onClick={() => listarRegionais(1)}>
                <FontAwesomeIcon icon={faFilter} style={{ marginRight: '5px' }} />
                Aplicar
              </Button>
              <Button variant="secondary" onClick={() => {/* Lógica para limpar filtros aqui, se desejar */}}>
                <FontAwesomeIcon icon={faRefresh} style={{ marginRight: '5px' }} />
                Limpar
              </Button>
            </div>
          </>
        )}

        {loading ? <Spinner loading={loading} /> : (
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th scope="col" id="App-header-table">Código</th>
                  <th scope="col" id="App-header-table">Razão Social</th>
                  <th scope="col" id="App-header-table">Nome da Regional</th>
                  {/* <th scope="col" id="App-header-table">Cidade</th> */}
                  <th scope="col" id="App-header-table">Telefone</th>
                  <th scope="col" id="App-header-table">Email</th>
                  <ProtectedAction>
                    <th scope="col" id="App-header-table">Alteração</th>
                    <th scope="col" id="App-header-table">Status</th>
                  </ProtectedAction>
                </tr>
              </thead>
              <tbody>
                {regional.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.razaoSocial}</td>
                    <td>{item.nome}</td>
                    {/* <td>{item.cidade}</td> */}
                    <td>{item.telefoneComercial}</td>
                    <td>{item.email}</td>
                    <ProtectedAction>
                      <td>
                        {/* 4. Link de alteração com Slug */}
                        <Link to={`/${slug}/origens-regional/alteracao`} state={{ id: item.id }}>
                          <ButtonAlterar />
                        </Link>
                      </td>
                      <td>
                        {item.ativo ? (
                          <ButtonInativar onClick={() => ativarInativarRegional(item.id, item.ativo)} />
                        ) : (
                          <ButtonAtivar onClick={() => ativarInativarRegional(item.id, item.ativo)} />
                        )}
                      </td>
                    </ProtectedAction>  
                  </tr>
                ))}
              </tbody>
            </table>

            <ResponsivePagination
              current={currentPage}
              total={totalPages}
              onPageChange={handlePageChange}
            />
            
            {confirmOpen && (<ConfirmModal message={currentAction?.ativo ? 'Tem certeza que deseja inativar este item?' : 'Tem certeza que deseja ativar este item?'} onConfirm={handleConfirm} onCancel={() => { setConfirmOpen(false); setCurrentAction(null) }} />)}
          </div>
        )}
      </div>
    </>
  );
}

export default RegionalComponent;